import React from "react";

import { templates, Context } from "@reactivated";

import {Layout} from "@client/components/Layout";
import { Label } from "@client/shadcn/ui/label";
import { ProjectCard } from "@client/components/ProjectCard";
import { ProjectAdd } from "@client/components/ProjectAdd";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@client/shadcn/ui/select";
import { ArrowUpDown } from "lucide-react";


export const Template = (props: templates.ProjectsList) => {
    return (
        <Layout title="Projects">
        <div className="container mx-auto px-4 py-8">
            <div className="flex flex-row justify-between content-center mb-8">
                <div>
                    <div className="flex flex-row justify-left align-center gap-2">
                        <Label className="text-3xl font-bold mb-2">
                            Projects
                        </Label>
                        {props.can_add ? <ProjectAdd /> : null}
                    </div>
                    <Label>Browse, filter, and manage your English Language Teaching projects in one place.</Label>
                </div>
                <div className="flex flex-col gap-2">
                    <Label>Sort by</Label>
                    <Select
                        defaultValue={URL.parse(React.useContext(Context).request.url)?.searchParams.get("ordering") || "-updated_at"}
                        onValueChange={(value: string) => {
                            const searchParams = new URLSearchParams(window.location.search);
                            searchParams.set('ordering', value);
                            window.location.search = searchParams.toString();
                        }}
                    >
                        <SelectTrigger>
                            <ArrowUpDown />
                            <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem value="title">Alphabetical</SelectItem>
                            <SelectItem value="-updated_at">Recently updated</SelectItem>
                            <SelectItem value="start_date">Start date</SelectItem>
                        </SelectContent>
                    </Select>
                </div>
            </div>
            

            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {props.projects.map((project) =>
                    <ProjectCard
                        id={project.id}
                        title={project.title}
                        details={JSON.parse(project.details)}
                        coverImage={project.splash_art.url}
                        status={project.status}
                        progress={project.progress}
                        tags={project.tags}
                        canEdit={props.can_edit.map((item) => item.id).includes(project.id)}
                    ></ProjectCard>
                )}
            </div>
        </div>

        </Layout>
    );
}